// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"692":"8319bbf8","884":"a2ae1218"}[chunkId] + ".chunk.js";
};